import PropTypes from 'prop-types';

const SaveAddSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M26.6663 14.9834V33.9167C26.6663 36.3334 24.933 37.35 22.8163 36.1834L16.2664 32.5334C15.5664 32.15 14.433 32.15 13.733 32.5334L7.183 36.1834C5.06634 37.35 3.33301 36.3334 3.33301 33.9167V14.9834C3.33301 12.1334 5.66632 9.80005 8.51632 9.80005H21.483C24.333 9.80005 26.6663 12.1334 26.6663 14.9834Z"
        fill={color}
      />
      <path
        d="M36.6663 8.51668V27.45C36.6663 29.8667 34.933 30.8834 32.8163 29.7167L26.6663 26.2834V14.9834C26.6663 12.1334 24.333 9.80005 21.483 9.80005H13.333V8.51668C13.333 5.66668 15.6663 3.33337 18.5163 3.33337H31.483C34.333 3.33337 36.6663 5.66668 36.6663 8.51668Z"
        fill={color}
      />
      <path
        d="M18.3337 18.75H16.2503V16.6666C16.2503 15.9833 15.6837 15.4166 15.0003 15.4166C14.317 15.4166 13.7503 15.9833 13.7503 16.6666V18.75H11.667C10.9837 18.75 10.417 19.3166 10.417 20C10.417 20.6833 10.9837 21.25 11.667 21.25H13.7503V23.3333C13.7503 24.0166 14.317 24.5833 15.0003 24.5833C15.6837 24.5833 16.2503 24.0166 16.2503 23.3333V21.25H18.3337C19.017 21.25 19.5837 20.6833 19.5837 20C19.5837 19.3166 19.017 18.75 18.3337 18.75Z"
        fill={color}
      />
    </svg>
  );
};

SaveAddSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SaveAddSvg;
